'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');let

DoNotDisturbNotificationSettingsDirective=class DoNotDisturbNotificationSettingsDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'emailAddress'];

}

get templateUrl(){
return'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/doNotDisturbNotificationSettingsView';
}

get controller(){
return DoNotDisturbNotificationSettingsController;
}};let


DoNotDisturbNotificationSettingsController=(_class=class DoNotDisturbNotificationSettingsController extends BaseController{
static get $inject(){
return['$timeout','$modal','$element','uncaughtErrorHandler','socketService','notificationService','uiCommandFactory'];
}

constructor($timeout,$modal,$element,uncaughtErrorHandler,socketService,notificationService,uiCommandFactory){
super(uncaughtErrorHandler);

this._$timeout=$timeout;
this._$modal=$modal;
this._$element=$element;
this._socketService=socketService;
this._notificationService=notificationService;
this._uiCommandFactory=uiCommandFactory;

this._controllerInitialized=!1;
this._pendingDeletions={};

this.onForwardingEnabledChangeCommand=this._uiCommandFactory.make(this._onToggleForwardingEnabled.bind(this));

this._getNotificationSettings();
}

addDoNotDisturbSchedule(){
let addDoNotDisturbScheduleModal=this._$modal.open({
templateUrl:'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/modals/addDoNotDisturbScheduleModalView',
controller:'AddDoNotDisturbScheduleModalController as controller',
windowClass:'add-schedule',
resolve:{
onScheduleAdded:()=>this._handleErrorsAndRebuildViewModels.bind(this)}});


}

editForwardingAddress(emailAddress){
let addDoNotDisturbScheduleModal=this._$modal.open({
templateUrl:'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/modals/editForwardingAddressModalView',
controller:'EditForwardingAddressModalController as controller',
windowClass:'edit-forwarding-address',
resolve:{
emailAddress:()=>emailAddress,
onAddressListUpdated:()=>this._handleErrorsAndRebuildViewModels.bind(this)}});


}

addForwardingAddress(){
let addDoNotDisturbScheduleModal=this._$modal.open({
templateUrl:'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/modals/addForwardingAddressModalView',
controller:'AddForwardingAddressModalController as controller',
resolve:{
onAddressListUpdated:()=>this._handleErrorsAndRebuildViewModels.bind(this)}});


}


async _getNotificationSettings(){
let notificationSettingsResponse=await this._socketService.sendAndWaitForResponse('GetNotificationSettings');

await this._handleErrorsAndRebuildViewModels(notificationSettingsResponse,!0);
}


async _handleErrorsAndRebuildViewModels(notificationSettingsResponse,isGettingNotificationSettings=!1){
if(!SocketResponse.succeeded(notificationSettingsResponse)){
if(!isGettingNotificationSettings){
this._notificationService.displayNotification('An unexpected error occurred updating settings, please contact support.','error');
await this._getNotificationSettings();
}else{
this._notificationService.displayNotification('Failed to retrieve notification settings.','error');
}
return;
}

this._makeViewModelsFromLatestSettings(notificationSettingsResponse.body);
}

_makeViewModelsFromLatestSettings(notificationSettings){
let oldSchedulesById=_.keyBy(this._doNotDisturbSchedules,'id');

notificationSettings.doNotDisturbSchedules.forEach(schedule=>{
let preExistingSchedule=oldSchedulesById[schedule.id];

schedule.togglePauseScheduleCommand=
_.exists(preExistingSchedule)?preExistingSchedule.togglePauseScheduleCommand:this._uiCommandFactory.make(this._onTogglePauseSchedule.bind(this));

schedule.deleteScheduleCommand=
_.exists(preExistingSchedule)?preExistingSchedule.deleteScheduleCommand:this._uiCommandFactory.make(this._onScheduleDeleted.bind(this));
});

for(let pendingDeletion of _(this._pendingDeletions).values().sortBy(pd=>pd.index).value()){
notificationSettings.doNotDisturbSchedules.splice(pendingDeletion.index,0,pendingDeletion.schedule);
}

this._$timeout(()=>{
this._doNotDisturbSchedules=notificationSettings.doNotDisturbSchedules;
this._forwardingEnabled=notificationSettings.forwardingEnabled;
this._forwardingAddressList=notificationSettings.forwardingAddressList;

this._controllerInitialized=!0;
});
}


async _onToggleForwardingEnabled(newIsEnabledValue){
let notificationSettingsResponse=
await this._socketService.sendAndWaitForResponse(newIsEnabledValue?'EnableNotificationForwarding':'DisableNotificationForwarding');

await this._handleErrorsAndRebuildViewModels(notificationSettingsResponse);
}


async _onTogglePauseSchedule(scheduleViewModel){
let notificationSettingsResponse=
await this._socketService.sendAndWaitForResponse(scheduleViewModel.isPaused?'UnpauseDoNotDisturbSchedule':'PauseDoNotDisturbSchedule',scheduleViewModel.id);

await this._handleErrorsAndRebuildViewModels(notificationSettingsResponse);
}


async _onScheduleDeleted(schedule){
let notificationSettingsResponse=await this._socketService.sendAndWaitForResponse('DeleteDoNotDisturbSchedule',schedule.id);

this._addScheduleToPendingDeletions(schedule);

await this._handleErrorsAndRebuildViewModels(notificationSettingsResponse);
}

_addScheduleToPendingDeletions(schedule){
schedule.deleted=!0;

this._pendingDeletions[schedule.id]={
timer:this._$timeout(()=>{
let directiveElement=this._$element.find(`#${schedule.id}`).parent();
directiveElement.slideUp(382,()=>{
this._$timeout(()=>{
_.remove(this._doNotDisturbSchedules,this._pendingDeletions[schedule.id].schedule);
delete this._pendingDeletions[schedule.id];
});
});
},618),
schedule:schedule,
index:this._doNotDisturbSchedules.indexOf(schedule)};

}

get doNotDisturbSchedules(){
return this._doNotDisturbSchedules;
}

get forwardingEnabled(){
return this._forwardingEnabled;
}

set forwardingEnabled(forwardingEnabled){
this._forwardingEnabled=forwardingEnabled;
}

get forwardingAddressList(){
return this._forwardingAddressList;
}},(_applyDecoratedDescriptor(_class.prototype,'_getNotificationSettings',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_getNotificationSettings'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_handleErrorsAndRebuildViewModels',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_handleErrorsAndRebuildViewModels'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onToggleForwardingEnabled',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onToggleForwardingEnabled'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onTogglePauseSchedule',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onTogglePauseSchedule'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_onScheduleDeleted',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_onScheduleDeleted'),_class.prototype)),_class);


module.exports=DoNotDisturbNotificationSettingsDirective;
module.exports.controller=DoNotDisturbNotificationSettingsController;
//# sourceMappingURL=doNotDisturbNotificationSettingsDirective.js.map
